import { button, el } from './dom.js';

interface OverlayOptions {
  readonly title: string;
  readonly bodyLines: readonly string[];
  readonly primary: { label: string; onClick: () => void };
  readonly secondary?: { label: string; onClick: () => void };
}

const showOverlay = (parent: HTMLElement, opts: OverlayOptions): { close: () => void } => {
  const close = (): void => {
    if (overlay.parentElement) overlay.parentElement.removeChild(overlay);
  };

  const primaryBtn = button(opts.primary.label, 'big-btn', () => {
    opts.primary.onClick();
    close();
  });

  const cardChildren: HTMLElement[] = [
    el('h1', { text: opts.title }),
    el('p', { children: linesToNodes(opts.bodyLines) }),
    primaryBtn,
  ];
  if (opts.secondary) {
    const ghost = button(opts.secondary.label, 'ghost-btn', () => {
      opts.secondary?.onClick();
      close();
    });
    cardChildren.push(el('div', { children: [ghost] }));
  }

  const overlay = el('div', {
    className: 'overlay',
    children: [el('div', { className: 'overlay-card', children: cardChildren })],
  });
  parent.appendChild(overlay);
  return { close };
};

const linesToNodes = (lines: readonly string[]): (HTMLElement | string)[] => {
  const out: (HTMLElement | string)[] = [];
  lines.forEach((line, i) => {
    if (i > 0) out.push(el('br'));
    out.push(line);
  });
  return out;
};

export const showStart = (
  parent: HTMLElement,
  level: number,
  onStart: () => void,
  onHelp: () => void,
): void => {
  showOverlay(parent, {
    title: 'CBLIX2',
    bodyLines: [
      '3D color flood puzzle.',
      'Connect the white halo to the gold halo by picking colors.',
      `Level ${level}.`,
    ],
    primary: { label: 'Play ▶', onClick: onStart },
    secondary: { label: 'How to play', onClick: onHelp },
  });
};

export const showWin = (
  parent: HTMLElement,
  level: number,
  used: number,
  budget: number,
  onNext: () => void,
): void => {
  showOverlay(parent, {
    title: 'Solved!',
    bodyLines: [`Level ${level} cleared in ${used}/${budget} moves.`],
    primary: { label: 'Next ▶', onClick: onNext },
  });
};

export const showLose = (parent: HTMLElement, onRetry: () => void): void => {
  showOverlay(parent, {
    title: 'Out of moves',
    bodyLines: ['The corners did not connect this time.', 'Try the same level again.'],
    primary: { label: 'Retry', onClick: onRetry },
  });
};

export { showFullHelp as showHelp } from './help.js';
